module.exports = __webpack_public_path__ + "static/20230619_050-b56babb89f0dc41bb98d5ccdc6a3ea82.jpg";